import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "bottom" }
const _hoisted_3 = { class: "order-amount" }
const _hoisted_4 = { class: "order-amount-info" }
const _hoisted_5 = { class: "total-amount-text" }
const _hoisted_6 = { class: "order-actual-amount" }

import { onMounted, ref } from 'vue';
  import router from '@/router';
  import { useRoute } from 'vue-router';
  import { insertSaleInvoice, getSaleInvoiceList } from '@/service/saleInvoice';
  import h5Config from '@/config/config';
  import { showDialog, showSuccessToast } from 'vant';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'InvoiceManagementView',
  setup(__props) {

_useCssVars(_ctx => ({
  "7a8caa06": (_unref(h5Config).themeColor)
}))

  const route = useRoute();
  const orderCode = ref('');
  const invoiceAmount = ref(0);
  const title = ref('个人');
  const taxNo = ref('');
  const invoiceType = ref(1);
  const contentType = ref(2);
  const emailAddress = ref('');
  const isMobile = ref(true);

  onMounted(async () => {
    isMobile.value = isMobileDevice();
    orderCode.value = route.query.code || '';
    invoiceAmount.value = Number(route.query.amount || 0);
    loadInvoice();
    lockViewport();
  });

  const lockViewport = () => {
    let meta = document.querySelector('meta[name="viewport"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'viewport';
      document.head.appendChild(meta);
    }
    meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
  };

  const isMobileDevice = () => {
    if (typeof window === 'undefined') return false; // SSR 环境处理
    const ua = navigator.userAgent;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  };

  const loadInvoice = async () => {
    if (!orderCode.value) {
      return;
    }
    const invoiceListResp = await getSaleInvoiceList({
      pageNum: 1,
      pageSize: 1,
      data: {
        orderNo: orderCode.value,
        invoiceStatus: 10,
      },
    });
    const invoiceList = invoiceListResp?.result?.list || [];
    if (!invoiceList.length) return;

    const invoiceItem = invoiceList[0];
    const invoiceUrl = invoiceItem.invoiceUrl || '';
    if (invoiceUrl) {
      window.location.replace(invoiceUrl);
    }
  };

  const onClickLeft = () => {
    router.back();
  };

  const submitInvoice = async () => {
    if (!title.value) {
      showDialog({ message: '请输入开票名称' });
      return;
    }
    if (!invoiceAmount.value) {
      showDialog({ message: '开票金额不能为空' });
      return;
    }

    const insertInvoiceResp = await insertSaleInvoice({
      shopId: 2,
      title: title.value,
      taxNo: taxNo.value,
      orderNo: orderCode.value,
      invoiceAmount: invoiceAmount.value,
      emailAddress: emailAddress.value,
    });
    if (insertInvoiceResp.code === 200) {
      showSuccessToast({ message: '发票申请已提交，请稍后查看下载。' });
      loadInvoice();
    } else {
      showDialog({ message: insertInvoiceResp.msg || '开票失败' });
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: "开具发票",
      border: "",
      fixed: "",
      "left-arrow": "",
      onClickLeft: onClickLeft
    }, {
      left: _withCtx(() => [
        _createVNode(_component_van_icon, {
          name: "arrow-left",
          size: "22",
          color: "#000"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_field, {
      name: "invoiceType",
      label: "发票类型"
    }, {
      input: _withCtx(() => [
        _createVNode(_component_van_tag, {
          plain: "",
          size: "medium",
          color: invoiceType.value === 1 ? _unref(h5Config).themeColor : '',
          "text-color": invoiceType.value === 1 ? _unref(h5Config).themeColor : '',
          onClick: _cache[0] || (_cache[0] = ($event: any) => (invoiceType.value = 1))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" 个人 ")
          ])),
          _: 1,
          __: [4]
        }, 8, ["color", "text-color"])
      ]),
      _: 1
    }),
    _createVNode(_component_van_field, {
      name: "contentType",
      label: "内容"
    }, {
      input: _withCtx(() => [
        _createVNode(_component_van_tag, {
          plain: "",
          size: "medium",
          color: contentType.value === 2 ? _unref(h5Config).themeColor : '',
          "text-color": contentType.value === 2 ? _unref(h5Config).themeColor : '',
          onClick: _cache[1] || (_cache[1] = ($event: any) => (contentType.value = 2))
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode(" 商品类别 ")
          ])),
          _: 1,
          __: [5]
        }, 8, ["color", "text-color"])
      ]),
      _: 1
    }),
    _createVNode(_component_van_field, {
      modelValue: title.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((title).value = $event)),
      name: "title",
      label: "抬头",
      placeholder: "请输入抬头"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_van_field, {
      modelValue: emailAddress.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((emailAddress).value = $event)),
      name: "emailAddress",
      label: "邮箱",
      placeholder: "请输入邮箱"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-gray-600" }, "开票金额:", -1)),
            _createElementVNode("span", _hoisted_6, "¥" + _toDisplayString(invoiceAmount.value), 1)
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "ios-button",
        onClick: submitInvoice
      }, " 提交 ")
    ])
  ]))
}
}

})